import { render, staticRenderFns } from "./PosPatientComponent.vue?vue&type=template&id=2d3a52f1&scoped=true&"
import script from "./PosPatientComponent.vue?vue&type=script&lang=js&"
export * from "./PosPatientComponent.vue?vue&type=script&lang=js&"
import style0 from "./PosPatientComponent.vue?vue&type=style&index=0&id=2d3a52f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a52f1",
  null
  
)

export default component.exports